import React, {
  useState
} from 'react';

import PropTypes from 'prop-types';

import {
  MinusIcon,
  PlusIcon
} from 'src/Components/Common';

import './Pill.css';

const Pill = ({ label, content, defaultOpen = false }) => {

  const [ isOpen, setIsOpen ] = useState(defaultOpen);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="pill-container">
      <div className="pill-btn" onClick={handleToggle}>
        <p className='pill-label'>{label}</p>
        {isOpen ? <MinusIcon/> : <PlusIcon/>}
      </div>

      {isOpen && <div className='pill-content'>
        {content}
      </div>}
    </div>
  );
};

Pill.propTypes = {
  label: PropTypes.string,
  content: PropTypes.any,
  defaultOpen: PropTypes.bool
};

export default Pill;